import { useDisclosure, Autocomplete, AutocompleteItem } from "@heroui/react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "@heroui/react";
import { useState, useEffect } from "react";
import { api } from "@/api";
import { toast } from "react-toastify";
import useErrorHandling from "@/hooks/useErrorHandling";
import { Device } from "@/api/devices/devices";

export function CreateAccessCardModal({
  disclosure,
  onSuccess,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
  onSuccess?: () => void;
}) {
  const { isOpen, onOpenChange } = disclosure;
  const [devices, setDevices] = useState<Device[]>([]);
  const [selectedDeviceId, setSelectedDeviceId] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);
  const handleError = useErrorHandling();

  useEffect(() => {
    if (isOpen) {
      api.devices
        .list()
        .then((response) => {
          setDevices(
            response.data.map((device) => {
              return {
                ...device,
                name: `${device.name} (Этаж ${device.floor})`,
              };
            }),
          );
        })
        .catch((err) => {
          console.error(err);
          const { errorMessage } = handleError(err);
          toast.error(errorMessage);
        });
    } else {
      setSelectedDeviceId("");
    }
  }, [isOpen, handleError]);

  const handleSubmit = () => {
    if (!selectedDeviceId) {
      toast.error("Выберите устройство");
      return;
    }

    setIsLoading(true);
    api.accessCards
      .create({ device_id: Number(selectedDeviceId) })
      .then(() => {
        toast.success("Карта доступа успешно создана");
        setSelectedDeviceId("");
        onOpenChange();
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((err) => {
        console.error(err);
        const { errorMessage } = handleError(err);
        toast.error(errorMessage);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <Modal isOpen={isOpen} onOpenChange={onOpenChange} size="md">
      <ModalContent>
        <ModalHeader>Создание карты доступа</ModalHeader>
        <ModalBody>
          <Autocomplete
            label="Устройство"
            placeholder="Выберите устройство"
            variant="bordered"
            selectedKey={selectedDeviceId || null}
            onSelectionChange={(key) =>
              setSelectedDeviceId(key ? String(key) : "")
            }
            defaultItems={devices}>
            {(device) => (
              <AutocompleteItem key={String(device.id)}>
                {device.name}
              </AutocompleteItem>
            )}
          </Autocomplete>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onPress={handleSubmit} isLoading={isLoading}>
            Создать
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
